export default function () {
  controller('prod-add', self => {
    const $btn = $(self);
    const $item = $btn.closest('.js-prod-card');

    $item.each(function() {
      const self = $(this);
      const $popup = self.find('.js-prod-card-popup');

      $(document).on('click', function(e) {
        const $target = $(e.target);

        if (!$target.closest(self).length) {
          $popup.fadeOut(300);
        }
      });
    })

    $btn.on('click', function(event) {
      event.preventDefault();
      const self = $(this);
      const $card = self.closest('.js-prod-card');
      const $popup = $card.find('.js-prod-card-popup');

      if (!self.hasClass('is-added')) {
        self.addClass('is-added');
      } else {
        if (!$popup.find('input[type="checkbox"]').is(':checked')) {
          $popup.fadeIn(300);
        }
      }

      $('.js-drawer-wrap').removeClass('hide');
    })

    $btn
      .closest('.js-prod-card')
      .find('.js-prod-card-popup')
      .find('a')
      .on('click', function(event) {
        event.preventDefault();

        $('.js-prod-card-popup').fadeOut(300);
    });
  });
}
